import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChange } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreatmentMessageTemplate } from '../../dialogs/bulk-delivery-dialog/default-messages';
import { RichTextComponent } from '../../rich-text/rich-text.component';
import { TagModule } from 'primeng/tag';
import { OrganizationClient } from '../../../core/client/organization-client.service';
import { firstValueFrom, shareReplay } from 'rxjs';
import { Organization } from '../../../core/model/organization.model';
import { FabricationMethod } from '../../../core/model/fabrication-method';
import { RegionId } from '../../../core/model/region-id.enum';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { RxHelper } from '../../../core/utils/rxjxHelper';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

let cachedOrganizations: Organization[] | null;

@Component({
    selector: 'app-message-template-item',
    standalone: true,
    imports: [CommonModule, RichTextComponent, TagModule, ButtonModule, ConfirmPopupModule],
    templateUrl: './message-template-item.component.html',
    styleUrls: ['./message-template-item.component.scss'],
    providers: [RxHelper, ConfirmationService],
})
export class MessageTemplateItemComponent implements OnChanges {
    @Input() template?: TreatmentMessageTemplate | null;
    @Output() readonly edit = new EventEmitter<TreatmentMessageTemplate>();
    @Output() readonly delete = new EventEmitter<TreatmentMessageTemplate>();

    private readonly _organizationClient = inject(OrganizationClient);
    private readonly _confirmationService = inject(ConfirmationService);

    protected readonly organizations$ = this._organizationClient.list().pipe(shareReplay(1));
    protected organization?: Organization | null;

    async ngOnChanges(changes: Record<keyof MessageTemplateItemComponent, SimpleChange>) {
        if (changes.template) {
            if (this.template?.organizationId) {
                this.organization = (cachedOrganizations ??= await firstValueFrom(this.organizations$)).find(
                    x => x.id === this.template?.organizationId
                );
            } else {
                this.organization = null;
            }
        }
    }

    protected readonly FabricationMethod = FabricationMethod;
    protected readonly RegionId = RegionId;

    protected onClickDelete(event: Event) {
        if (this.template) {
            this._confirmationService.confirm({
                target: event.target as EventTarget,
                message: '确定要删除吗?',
                acceptLabel: '确定',
                rejectLabel: '取消',
                acceptButtonStyleClass: 'p-button-danger p-button-text p-button-xs',
                rejectButtonStyleClass: 'p-button-secondary p-button-text p-button-xs',
                key: 'confirm-delete-message-template',
                accept: () => {
                    this.delete.emit(this.template!);
                },
            });
        }
    }
}
